import { render, staticRenderFns } from "./RelatedMedia.vue?vue&type=template&id=3cdb9bdd&"
import script from "./RelatedMedia.vue?vue&type=script&lang=js&"
export * from "./RelatedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CIcon: require('@chakra-ui/vue').CIcon, CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CCollapse: require('@chakra-ui/vue').CCollapse})
